import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { TFunction } from 'i18next';

export interface FileUploadErrorInfo {
  readonly errorKey: string;
  readonly params?: Record<string, string>;
}

export function resolveFileUploadErrorMessage(
  errorData: FileUploadErrorInfo | string,
  t: TFunction,
  allowedFileSize?: string,
): string {
  const errorStr = typeof errorData === 'string' ? errorData : errorData.errorKey;
  const params = typeof errorData === 'object' ? errorData.params : undefined;

  if (!errorStr) {
    return '';
  }

  if (errorStr.startsWith('apk.error.')) {
    return t(errorStr.replace('apk.', ''), {
      ns: 'apk',
      defaultValue: t('error.invalidContent', { ns: 'apk' }),
      ...params,
    });
  }

  if (errorStr === 'file-too-large' && allowedFileSize) {
    return t('error.fileTooLarge', { ns: 'apk', size: allowedFileSize });
  }

  return t([`error.file.${errorStr}`, 'error.default'], { ns: ALL_LNGS_NAMESPACES.COMMON });
}
